module.exports = __webpack_public_path__ + "static/media/SAMSUNGPAY.6f30cad7.svg";